/* eslint-disable*/
import { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import moment from 'moment';
import styles from './MyRevenue.module.scss';
// import ListTable from '../../../../Components/ListTable/ListTable';
import { BackdropLoader } from '../../../Components/Loaders';
import ListTable from '../../../Components/ListTable/ListTable';
import ImageModal from '../../../Components/Modals/ImageModal/ImageModal';
import { modalActions } from '../../../Actions';
import { notificationServices } from '../../../Services';
import ImagesFinder from '../../../Components/ImagesFinder/ImagesFinder';
import storeServices from '../../../Services/Form Services/store.services';
import { Button } from '@mui/material';
import { Filter } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';
import { filtersInfoChip, handleExportData } from '@/Helpers';
import { useAuth } from '@/Components/Auth/Login/auth';

const TABLE_COLUMNS = [
	{
		title: 'ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Amount',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [];

const COLMAP = {
	ID: 'id',
	Store: 'storeId',
	Date: '_date',
	Amount: 'revenue',
};

function MyRevenue({ userPermissions, createPath, stores, toggleFiltersDrawer }) {
	const history = useHistory();
	const [isloading, setIsloading] = useState(false);
	const [usersData, setUsersData] = useState([]);
	const [selectedStore, setSelectedStore] = useState(null);
	const [filters, setFilters] = useState({});
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};

	const handleListFetch = async (filters) => {
		setIsloading(true);
		setFilters(filters);
		try {
			const response = await storeServices.fetchRevenues({
				data: {
					storeId: filters?.store?.id ?? '',
					dateRangeFilter: {
						from: moment(filters?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(filters?.dateRange?.to).format(
							'YYYY-MM-DD'
						),
					},
				},
			});
			if (response?.statusCode === 200) {
				setSelectedStore(selectedStore);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				setUsersData(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsloading(false);
		}
	};

	const SPECIAL_ITEMS = {
		Store: (storeId) => {
			const store = stores?.find((ele) => {
				return ele?.id === storeId;
			});
			return store?.name;
		},
		Amount: (revenue) => {
			let numStr = String(revenue);

			// Use regex to add commas after every 3 digits from the end
			numStr = numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

			return numStr;
		},
	};

	const handleAddClick = () => {
		history.push(createPath);
	};

	const filtersInfo = {
		header : {
			store :false,
			date: false,
		},

		filteredStore : {
			text : 'Revenue conducted at (Store)',
			show : true,
		},
		dateRangeOnly: {
			show : true,
		},
	};

	const exportInfo = {
		showExportBtn : true,
	};

	return (
		<div className={styles.root}>
			{/* <ListModal handleConfirm={iAmClicked} singleSelectable /> */}
			<BackdropLoader showProgress isLoading={isloading} />
			<ImageModal />
			<div className={styles.header}>
				<ImagesFinder
					allStoreOption={false}
					onSubmit={handleListFetch}
					storeTypes='RETAIL,BASE'
					filtersInfo={filtersInfo}
					exportInfo={exportInfo}
				/>
			</div>
			<div className='flex justify-between m-4 '>
				<span className='font-bold text-[16px]'>Revenue Listing</span>
				<div className='flex gap-2'>
				<Button
					onClick={() => {
						toggleFiltersDrawer(true, {
							exportFrontend: true,
							handleExportFrontend: () => handleExportData(usersData, COLMAP, 'Revenue Listing'),
						});
					}}
					className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span>Filter</span>
					<Filter className='size-4' />
				</Button>
				{level !== 1 && (
					<Button
						onClick={handleAddClick}
						className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
					>
						+ Add Revenue
					</Button>
				)}
				</div>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<ListTable
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={usersData}
				actions={[...SPECIAL_COLUMNS]}
				special={SPECIAL_ITEMS}
				showBtnContainer={false}
			/>
		</div>
	);
}
const mapStateToProps = (state) => {
	const { userPermissions } = state.navigation;
	const stores = state?.form?.STORES?.data?.LIST;

	return {
		userPermissions,
		stores,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleListModal,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyRevenue);
